module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-72649c21e70e299b9c118cd743716024.webp";